<div class="content-wrapper gradient-custom">
 <div class="container-fluid container mb-5">
<!-- start of student freshmigration dashboard -->
  <div *ngIf="isfreshmigration">
    <div class="row d-flex justify-content-center align-items-center h-100 " >
      <!-- Icon Cards-->
      <div class="card col-lg-8 fontsty inforide">
        <div class="card-body">
          <h2 class="h2">Welcome to Online Document Issuance Portal!!</h2>
        </div>
      </div> 
      <div class="card col-lg-10 mt-4 instruction ">
        <div class="card-body">
          <h2 class="text-center"><i class="bi bi-flower3"></i> Instructions <i class="bi bi-flower3"></i></h2>
          <h4 class="h4">1. Application will be accepted only if Student's result is PASS. </h4>
          <h4 class="h4">2. Required Documents for Migration Certificate:</h4>
          <h4 class="h4"><ul style="list-style-type: square">
            <li>Soft Copy of Statement of Marks of the last appeared examination of GBSHSE.</li>
            <li>Soft Copy of Passpost size photo</li>
            <!-- <li>Last appeared Exam Date,</li> -->
        </ul></h4>
          <h4 class="h4">3. You have to complete and submit application form in one attempt.</h4>
          <h4 class="h4">4. <span class="strip">*</span> marked fields is mandatory.</h4>
          <h4 class="h4">5. Check all tabs (Personal, Educational, Upload,Payment) carefully before submitting.</h4>
          <h4 class="h4">6. Information submitted once can not be modified later. </h4>
          <!-- <h4 class="h4">7. Request Letter from School</h4> -->
        </div>
      </div>
    </div>
</div>  
<!-- end of student dashboard -->
<!-- start of student namechagemarsheet  dashboard -->
  <div *ngIf="isnamechagemarsheet">
    <div class="row d-flex justify-content-center align-items-center h-100 " >
      <!-- Icon Cards-->
      <div class="card col-lg-8 fontsty inforide">
        <div class="card-body">
          <h2 class="h2">Welcome to Online Document Issuance Portal!!</h2>
        </div>
      </div> 
      <div class="card col-lg-10 mt-4 instruction ">
        <div class="card-body">
          <h2 class="text-center"><i class="bi bi-flower3"></i> Instructions <i class="bi bi-flower3"></i></h2>
          <h4 class="h4">1. Required Documents for <strong> Change On Marksheet:</strong></h4>
          <h5>
            <ul style="list-style-type: square">
              <li>Soft Copy of  Identity Proof, in which changed name is present</li>
              <li>Soft Copy of Passpost size photo</li>
              <li>Zonal permission letter</li>
              <li>Request Letter from School/Leaving certificate/General register copy (containing rectified name/parents name/date of birth)</li>
            </ul>
          </h5>
          <h4 class="h4">2. You have to complete and submit application form in one attempt.</h4>
          <h4 class="h4">3. <span class="strip">*</span> marked fields is mandatory.</h4>
          <h4 class="h4">4. Check all tabs (Personal, Educational, Upload,Payment) carefully before submitting.</h4>
          <h4 class="h4">5. Information submitted once can not be modified later. </h4>
          <h4 class="h4">6. Request Letter from School</h4>
        </div>
      </div>
    </div>
</div>  
<!-- end of student dashboard -->
<!-- start of student namechagepassingcert  dashboard -->
  <div *ngIf="isnamechagepassingcert">
    <div class="row d-flex justify-content-center align-items-center h-100 " >
      <!-- Icon Cards-->
      <div class="card col-lg-8 fontsty inforide">
        <div class="card-body">
          <h2 class="h2">Welcome to Online Document Issuance Portal!!</h2>
        </div>
      </div> 
      <div class="card col-lg-10 mt-4 instruction ">
        <div class="card-body">
          <h2 class="text-center"><i class="bi bi-flower3"></i> Instructions <i class="bi bi-flower3"></i></h2>
          <h4 class="h4">1. Application will be accepted only if Student's result is PASS. </h4>
          <h4 class="h4">2. Required Documents for <strong> Change On passing certificate:</strong></h4>
          <h5>
            <ul style="list-style-type: square">
              <li>Soft Copy of  Identity Proof, in which changed name is present</li>
              <li>Soft Copy of Passpost size photo</li>
              <li>Zonal permission letter</li>
              <li>Leaving certificate/General register copy (containing rectified name/parents name/date of birth)</li>            </ul>
          </h5>
          <h4 class="h4">3. You have to complete and submit application form in one attempt.</h4>
          <h4 class="h4">4. <span class="strip">*</span> marked fields is mandatory.</h4>
          <h4 class="h4">5. Check all tabs (Personal, Educational, Upload,Payment) carefully before submitting.</h4>
          <h4 class="h4">6. Information submitted once can not be modified later. </h4>
          <h4 class="h4">7. Request Letter from School</h4>
        </div>
      </div>
    </div>
</div>  
<!-- end of student dashboard -->

<!-- start of student duplimigration dashboard -->
  <div *ngIf="isduplimigration">
    <div class="row d-flex justify-content-center align-items-center h-100 " >
      <!-- Icon Cards-->
      <div class="card col-lg-8 fontsty inforide">
        <div class="card-body">
          <h2 class="h2">Welcome to Online Document Issuance Portal!!</h2>
        </div>
      </div> 
      <div class="card col-lg-10 mt-4 instruction ">
        <div class="card-body">
          <h2 class="text-center"><i class="bi bi-flower3"></i> Instructions <i class="bi bi-flower3"></i></h2>
          <h4 class="">1. Application will be accepted only if Student's result is PASS. </h4>
          <h4 class="h4">2. Required Documents for Duplicate Migration Certificate:</h4>
          <h4 class="h4"><ul style="list-style-type: square">
            <li>Soft Copy of Statement of Marks of the last appeared examination of GBSHSE.</li>
            <li>Soft Copy of Passpost size photo</li>
            <!-- <li>Last appeared Exam Date,</li> -->
        </ul></h4>
          <h4 class="h4">3. You have to complete and submit application form in one attempt.</h4>
          <h4 class="h4">4. <span class="strip">*</span> marked fields is mandatory.</h4>
          <h4 class="h4">5. Check all tabs (Personal, Educational, Upload,Payment) carefully before submitting.</h4>
          <h4 class="h4">6. Information submitted once can not be modified later. </h4>
          <h4 class="h4">7. Request Letter from School</h4>
        </div>
      </div>
    </div>
</div>  
<!-- end of student dashboard -->

<!-- start of student duplicate passingcertificate dashboard -->
  <div *ngIf="isduplicatepassingcertificate">
    <div class="row d-flex justify-content-center align-items-center h-100 " >
      <!-- Icon Cards-->
      <div class="card col-lg-8 fontsty inforide">
        <div class="card-body">
          <h2 class="h2">Welcome to Online Document Issuance Portal!!</h2>
        </div>
      </div> 
      <div class="card col-lg-10 mt-4 instruction ">
        <div class="card-body">
          <h2 class="text-center"><i class="bi bi-flower3"></i> Instructions <i class="bi bi-flower3"></i></h2>
          <h4 class="h4">1. Application will be accepted only if Student's result is PASS. </h4>
          <h4 class="h4">2. Required Documents for <strong> Duplicate Passing Certificate :</strong></h4>
          <h5>
            <ul style="list-style-type: square">
              <li>Soft Copy of Passpost size photo</li>
              <li>Soft Copy of  Identity Proof (Valid School/Government issued Identity document)</li>
              <li>Soft Copy of Request letter from school</li>
            </ul>
          </h5>
          <h4 class="h4">3. You have to complete and submit application form in one attempt.</h4>
          <h4 class="h4">4. <span class="strip">*</span> marked fields is mandatory.</h4>
          <h4 class="h4">5. Check all tabs (Personal, Educational, Upload,Payment) carefully before submitting.</h4>
          <h4 class="h4">6. Information submitted once can not be modified later. </h4>
          <h4 class="h4">7. Request Letter from School</h4>
        </div>
      </div>
    </div>
   
</div>  
<!-- end of student dashboard -->

<!-- start of student duplicate passingcertificate dashboard -->
  <div *ngIf="isduplicatemarsheet">
    <div class="row d-flex justify-content-center align-items-center h-100 " >
      <!-- Icon Cards-->
      <div class="card col-lg-8 fontsty inforide">
        <div class="card-body">
          <h2 class="h2">Welcome to Online Document Issuance Portal!!</h2>
        </div>
      </div> 
      <div class="card col-lg-10 mt-4 instruction ">
        <div class="card-body">
          <h2 class="text-center"><i class="bi bi-flower3"></i> Instructions <i class="bi bi-flower3"></i></h2>
          <h4 class="h4">1. Required Documents for <strong> Duplicate Marksheet :</strong></h4>
          <h5>
            <ul style="list-style-type: square">
              <li>Soft Copy of Passpost size photo</li>
              <li>Soft Copy of  Identity Proof (Valid School/Government issued Identity document)</li>
              <li>Soft Copy of Request letter from school</li>
            </ul>
          </h5>
          <h4 class="h4">2. You have to complete and submit application form in one attempt.</h4>
          <h4 class="h4">3. <span class="strip">*</span> marked fields is mandatory.</h4>
          <h4 class="h4">4. Check all tabs (Personal, Educational, Upload,Payment) carefully before submitting.</h4>
          <h4 class="h4">5. Information submitted once can not be modified later. </h4>
          <h4 class="h4">6. Request Letter from School</h4>
        </div>
      </div>
    </div>
   
</div>  
<!-- end of student dashboard -->




<!-- start of board admin dashboard -->
  <div *ngIf="isboardadmin || isboardcord">  
    <h2 class="text-center" style="text-decoration: underline;">Online Document Issuance Portal</h2>   
    <div class="row my-5">
        <div class="col-md-6">
          <div class="card fontsty inforide">
            <div class="card-body">
              <h5 class="card-title text-center hover-underline-animation">{{allSubmittedRequest_title}}</h5>
                <div *ngIf="!noHSSCData" class="chartadjust">
                  <div class="chart-label">  <span class="dot1 dot11"></span>Fresh Migration Certificate : {{allSubmittedRequests.fresh_migration}}</div>
                  <div class="chart-label"> <span class="dot1 dot22"></span>Duplicate Passing Certificate : {{allSubmittedRequests.duplicate_passing_certificate}}</div>
                  <div class="chart-label"> <span class="dot1 dot33"></span>Duplicate Migration Certificate : {{allSubmittedRequests.duplicate_migration}}</div>
                  <div class="chart-label"> <span class="dot1 dot44"></span>Duplicate Marksheet : {{allSubmittedRequests.duplicate_marksheet}} </div>
                  <div class="chart-label"> <span class="dot1 dot55"></span>Change Request On Marksheet : {{allSubmittedRequests.chg_marksheet}}</div>
                  <div class="chart-label"> <span class="dot1 dot66"></span>Change Request On Passing Certificate : {{allSubmittedRequests.chg_passing_certificate}}</div>
                 
                  <google-chart #chart                
                  [type]="allSubmittedRequest_type"
                  [data]="allSubmittedRequest_data"                
                  [options]="allSubmittedRequest_options"
                  [width]="allSubmittedRequest_width"
                  [height]="allSubmittedRequest_height">                       
                </google-chart>
                
              </div>
              <div *ngIf="noHSSCData">
                <div class="alert alert-warning text-center">
                  <p class="h5"><i class="bi bi-hourglass-split"></i><br>No Application Is Submitted Yet !!</p>
              </div>
              </div>
            </div>
          </div> 
        </div>
        <div class="col-md-6">
          <div class="card fontsty inforide">
            <div class="card-body">
              <h5 class="card-title text-center hover-underline-animation">{{allSubmittedRequestSSC_title}}</h5>
                <div *ngIf="!noSSCData" class="chartadjust">
                  <div class="chart-label">  <span class="dot1 dot111"></span>Fresh Migration Certificate : {{allSubmittedRequests.SSCfresh_migration}}</div>
                  <div class="chart-label"> <span class="dot1 dot222"></span>Duplicate Passing Certificate : {{allSubmittedRequests.SSCduplicate_passing_certificate}}</div>
                  <div class="chart-label"> <span class="dot1 dot333"></span>Duplicate Migration Certificate : {{allSubmittedRequests.SSCduplicate_migration}}</div>
                  <div class="chart-label"> <span class="dot1 dot444"></span>Duplicate Marksheet : {{allSubmittedRequests.SSCduplicate_marksheet}} </div>
                  <div class="chart-label"> <span class="dot1 dot555"></span>Change Request On Marksheet : {{allSubmittedRequests.SSCchg_marksheet}}</div>
                  <div class="chart-label"> <span class="dot1 dot666"></span>Change Request On Passing Certificate : {{allSubmittedRequests.SSCchg_passing_certificate}}</div>
                  <google-chart #chart                
                  [type]="allSubmittedRequestSSC_type"
                  [data]="allSubmittedRequestSSC_data"                
                  [options]="allSubmittedRequestSSC_options"
                  [width]="allSubmittedRequestSSC_width"
                  [height]="allSubmittedRequestSSC_height">                       
                </google-chart>
              </div>
              <div *ngIf="noSSCData">
                <div class="alert alert-info text-center">
                  <p class="h5"><i class="bi bi-hourglass-split"></i><br>No Application Is Submitted Yet !!</p>
              </div>
              </div>
            </div>
          </div> 
        </div>
        <!-- <div class="col-md-6">
          <div class="card fontsty inforide">
            <div class="card-body">
              <h5 class="card-title text-center hover-underline-animation">{{migrationStatusCount_title}}</h5>
                <div class="chartadjust">
                  <google-chart #chart                
                  [type]="migrationStatusCount_type"
                  [data]="migrationStatusCount_data"                
                  [options]="migrationStatusCount_options"
                  [width]="migrationStatusCount_width"
                  [height]="migrationStatusCount_height">                       
                </google-chart>
              </div>
            </div>
          </div> 
        </div>       -->
    </div>
    
  </div>
<!-- end of board admin dashboard -->
<a *ngIf="isfreshmigration" href=""  [routerLink]="['/applynewmigration']" class="btn btn-warning nxtbtn" >Next</a>
<a *ngIf="isnamechagemarsheet" href=""  [routerLink]="['/applynamechange']" class="btn btn-warning nxtbtn" >Next</a>
<a *ngIf="isnamechagepassingcert" href=""  [routerLink]="['/applynamechange']" class="btn btn-warning nxtbtn" >Next</a>
<a *ngIf="isduplimigration" href=""  [routerLink]="['/applyduplicatemigration']" class="btn btn-warning nxtbtn" >Next</a>
<a *ngIf="isduplicatemarsheet" href=""  [routerLink]="['/applyduplicatemarsksheet']" class="btn btn-warning nxtbtn" >Next</a>
<a *ngIf="isduplicatepassingcertificate" href=""  [routerLink]="['/applyduplicatemarsksheet']" class="btn btn-warning nxtbtn" >Next</a>

</div>
</div>
